<template>
	<table border="0" style='width:100%'>
		<tbody>
			<tr>
				<td :style="{verticalAlign:valign}">
					<slot/>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
export default {
props:["valign"],
  name: 'i-td',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>